/* tslint:disable */
/* eslint-disable */
/**
 * mindd-stim3-home-api-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CancelPrescriptionRequest } from '../model';
// @ts-ignore
import type { CreatePrescriptionRequest } from '../model';
// @ts-ignore
import type { CreateRequest } from '../model';
// @ts-ignore
import type { Device } from '../model';
// @ts-ignore
import type { Prescription } from '../model';
// @ts-ignore
import type { PrescriptionDefaultParam } from '../model';
// @ts-ignore
import type { ReplaceRequest } from '../model';
// @ts-ignore
import type { SearchPrescriptionRequest } from '../model';
// @ts-ignore
import type { UpdateRequest } from '../model';
/**
 * PrescriptionControllerApi - axios parameter creator
 * @export
 */
export const PrescriptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 처방을 취소합니다. 병원 계정은 배송 요청 전까지만, YBRAIN 계정은 제약 없이 취소할 수 있습니다.
         * @summary 처방 취소
         * @param {string} prescriptionId 
         * @param {CancelPrescriptionRequest} cancelPrescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (prescriptionId: string, cancelPrescriptionRequest: CancelPrescriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('cancel', 'prescriptionId', prescriptionId)
            // verify required parameter 'cancelPrescriptionRequest' is not null or undefined
            assertParamExists('cancel', 'cancelPrescriptionRequest', cancelPrescriptionRequest)
            const localVarPath = `/api/v1/prescriptions/{prescriptionId}/cancel`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelPrescriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 자극 기본값 추가
         * @param {CreateRequest} createRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultPrescriptionParam: async (createRequest: CreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRequest' is not null or undefined
            assertParamExists('createDefaultPrescriptionParam', 'createRequest', createRequest)
            const localVarPath = `/api/v1/prescriptions/default-param`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 처방 생성
         * @param {CreatePrescriptionRequest} createPrescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrescription: async (createPrescriptionRequest: CreatePrescriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPrescriptionRequest' is not null or undefined
            assertParamExists('createPrescription', 'createPrescriptionRequest', createPrescriptionRequest)
            const localVarPath = `/api/v1/prescriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPrescriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 자극 기본값 삭제
         * @param {string} prescriptionDefaultParamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDefaultPrescriptionParam: async (prescriptionDefaultParamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionDefaultParamId' is not null or undefined
            assertParamExists('deleteDefaultPrescriptionParam', 'prescriptionDefaultParamId', prescriptionDefaultParamId)
            const localVarPath = `/api/v1/prescriptions/default-param/{prescriptionDefaultParamId}`
                .replace(`{${"prescriptionDefaultParamId"}}`, encodeURIComponent(String(prescriptionDefaultParamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 처방 id 에 해당하는 처방 삭제
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrescriptionById: async (prescriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('deletePrescriptionById', 'prescriptionId', prescriptionId)
            const localVarPath = `/api/v1/prescriptions/{prescriptionId}`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 토큰의 병원에 속한 미종결(대기·진행중) 처방을 최신 처방순으로 반환한다. includeClosedWithinDays 를 주면 오늘 포함 그 일수 안에 종결(완료·취소)된 처방도 함께 담는다(1~90, 벗어나면 400). 상태는 Prescription.Status 값만 담으며, 미동의·배송지 미입력·배송중 같은 배송 세부 상태는 이 응답에 없다 — 클라이언트가 배송 서버 정보와 결합해 구분해야 한다.
         * @summary 기관 미종결 처방 목록 조회 (이용 현황 화면)
         * @param {number} [includeClosedWithinDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActivePrescriptions: async (includeClosedWithinDays?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/prescriptions/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeClosedWithinDays !== undefined) {
                localVarQueryParameter['includeClosedWithinDays'] = includeClosedWithinDays;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 배송 서버가 발행한 옛 토큰(QX_DEVICE_USER)의 patientId/orgId 에 해당하는 처방 리스트를 반환합니다. 새 환자 서버 토큰은 GET /api/v1/me/prescriptions 를 사용하세요.
         * @summary 모바일 사용자 본인의 처방 목록 조회 (옛 배송 토큰 전용, deprecated)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findAllMyPrescriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/prescriptions/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 환자 id 에 해당하는 처방 조회
         * @param {string} patientId 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllPrescriptionsByPatientId: async (patientId: string, includeDeleted?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('findAllPrescriptionsByPatientId', 'patientId', patientId)
            const localVarPath = `/api/v1/prescriptions/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 자극 기본값 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDefaultParam: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/prescriptions/default-param`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 처방 id 에 해당하는 처방 조회
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPrescriptionById: async (prescriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('findPrescriptionById', 'prescriptionId', prescriptionId)
            const localVarPath = `/api/v1/prescriptions/{prescriptionId}`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 배송완료 후 직원이 기기를 직접 교환합니다. 헌 기기는 회수 대기(RELEASING) 상태로 두고 새 기기를 활성화하며, 배송 deviceId 도 교체합니다. 헌 기기의 최종 상태는 회수·점검 단계에서 정합니다. YBRAIN 권한 소유자만 호출 가능합니다.
         * @summary 기기 직접 교환 (YBRAIN 전용)
         * @param {string} prescriptionId 
         * @param {ReplaceRequest} replaceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceDevice: async (prescriptionId: string, replaceRequest: ReplaceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('replaceDevice', 'prescriptionId', prescriptionId)
            // verify required parameter 'replaceRequest' is not null or undefined
            assertParamExists('replaceDevice', 'replaceRequest', replaceRequest)
            const localVarPath = `/api/v1/prescriptions/{prescriptionId}/replace-device`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * prescription id 목록을 받아 해당 처방들을 한 번에 조회한다. 존재하지 않는 id 는 스킵(부분 성공)하고 삭제된 처방은 제외한다. YBRAIN 권한 소유자만 호출 가능하며 org 제약 없이 전체 처방을 대상으로 한다.
         * @summary 처방 id 목록 벌크 조회 (YBRAIN 전용)
         * @param {SearchPrescriptionRequest} searchPrescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPrescriptionsByIds: async (searchPrescriptionRequest: SearchPrescriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchPrescriptionRequest' is not null or undefined
            assertParamExists('searchPrescriptionsByIds', 'searchPrescriptionRequest', searchPrescriptionRequest)
            const localVarPath = `/api/v1/prescriptions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchPrescriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 자극 기본값 업데이트
         * @param {string} prescriptionDefaultParamId 
         * @param {UpdateRequest} updateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultPrescriptionParam: async (prescriptionDefaultParamId: string, updateRequest: UpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionDefaultParamId' is not null or undefined
            assertParamExists('updateDefaultPrescriptionParam', 'prescriptionDefaultParamId', prescriptionDefaultParamId)
            // verify required parameter 'updateRequest' is not null or undefined
            assertParamExists('updateDefaultPrescriptionParam', 'updateRequest', updateRequest)
            const localVarPath = `/api/v1/prescriptions/default-param/{prescriptionDefaultParamId}`
                .replace(`{${"prescriptionDefaultParamId"}}`, encodeURIComponent(String(prescriptionDefaultParamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrescriptionControllerApi - functional programming interface
 * @export
 */
export const PrescriptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrescriptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 처방을 취소합니다. 병원 계정은 배송 요청 전까지만, YBRAIN 계정은 제약 없이 취소할 수 있습니다.
         * @summary 처방 취소
         * @param {string} prescriptionId 
         * @param {CancelPrescriptionRequest} cancelPrescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(prescriptionId: string, cancelPrescriptionRequest: CancelPrescriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Prescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(prescriptionId, cancelPrescriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 자극 기본값 추가
         * @param {CreateRequest} createRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDefaultPrescriptionParam(createRequest: CreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrescriptionDefaultParam>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDefaultPrescriptionParam(createRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.createDefaultPrescriptionParam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 처방 생성
         * @param {CreatePrescriptionRequest} createPrescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrescription(createPrescriptionRequest: CreatePrescriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Prescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrescription(createPrescriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.createPrescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 자극 기본값 삭제
         * @param {string} prescriptionDefaultParamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDefaultPrescriptionParam(prescriptionDefaultParamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDefaultPrescriptionParam(prescriptionDefaultParamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.deleteDefaultPrescriptionParam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 처방 id 에 해당하는 처방 삭제
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePrescriptionById(prescriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrescriptionById(prescriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.deletePrescriptionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 토큰의 병원에 속한 미종결(대기·진행중) 처방을 최신 처방순으로 반환한다. includeClosedWithinDays 를 주면 오늘 포함 그 일수 안에 종결(완료·취소)된 처방도 함께 담는다(1~90, 벗어나면 400). 상태는 Prescription.Status 값만 담으며, 미동의·배송지 미입력·배송중 같은 배송 세부 상태는 이 응답에 없다 — 클라이언트가 배송 서버 정보와 결합해 구분해야 한다.
         * @summary 기관 미종결 처방 목록 조회 (이용 현황 화면)
         * @param {number} [includeClosedWithinDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findActivePrescriptions(includeClosedWithinDays?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Prescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findActivePrescriptions(includeClosedWithinDays, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.findActivePrescriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 배송 서버가 발행한 옛 토큰(QX_DEVICE_USER)의 patientId/orgId 에 해당하는 처방 리스트를 반환합니다. 새 환자 서버 토큰은 GET /api/v1/me/prescriptions 를 사용하세요.
         * @summary 모바일 사용자 본인의 처방 목록 조회 (옛 배송 토큰 전용, deprecated)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findAllMyPrescriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Prescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllMyPrescriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.findAllMyPrescriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 환자 id 에 해당하는 처방 조회
         * @param {string} patientId 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllPrescriptionsByPatientId(patientId: string, includeDeleted?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Prescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllPrescriptionsByPatientId(patientId, includeDeleted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.findAllPrescriptionsByPatientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 자극 기본값 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDefaultParam(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrescriptionDefaultParam>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findDefaultParam(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.findDefaultParam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 처방 id 에 해당하는 처방 조회
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPrescriptionById(prescriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Prescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPrescriptionById(prescriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.findPrescriptionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 배송완료 후 직원이 기기를 직접 교환합니다. 헌 기기는 회수 대기(RELEASING) 상태로 두고 새 기기를 활성화하며, 배송 deviceId 도 교체합니다. 헌 기기의 최종 상태는 회수·점검 단계에서 정합니다. YBRAIN 권한 소유자만 호출 가능합니다.
         * @summary 기기 직접 교환 (YBRAIN 전용)
         * @param {string} prescriptionId 
         * @param {ReplaceRequest} replaceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceDevice(prescriptionId: string, replaceRequest: ReplaceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Device>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceDevice(prescriptionId, replaceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.replaceDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * prescription id 목록을 받아 해당 처방들을 한 번에 조회한다. 존재하지 않는 id 는 스킵(부분 성공)하고 삭제된 처방은 제외한다. YBRAIN 권한 소유자만 호출 가능하며 org 제약 없이 전체 처방을 대상으로 한다.
         * @summary 처방 id 목록 벌크 조회 (YBRAIN 전용)
         * @param {SearchPrescriptionRequest} searchPrescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPrescriptionsByIds(searchPrescriptionRequest: SearchPrescriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Prescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPrescriptionsByIds(searchPrescriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.searchPrescriptionsByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 자극 기본값 업데이트
         * @param {string} prescriptionDefaultParamId 
         * @param {UpdateRequest} updateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDefaultPrescriptionParam(prescriptionDefaultParamId: string, updateRequest: UpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrescriptionDefaultParam>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDefaultPrescriptionParam(prescriptionDefaultParamId, updateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionControllerApi.updateDefaultPrescriptionParam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrescriptionControllerApi - factory interface
 * @export
 */
export const PrescriptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrescriptionControllerApiFp(configuration)
    return {
        /**
         * 처방을 취소합니다. 병원 계정은 배송 요청 전까지만, YBRAIN 계정은 제약 없이 취소할 수 있습니다.
         * @summary 처방 취소
         * @param {string} prescriptionId 
         * @param {CancelPrescriptionRequest} cancelPrescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(prescriptionId: string, cancelPrescriptionRequest: CancelPrescriptionRequest, options?: any): AxiosPromise<Prescription> {
            return localVarFp.cancel(prescriptionId, cancelPrescriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 자극 기본값 추가
         * @param {CreateRequest} createRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultPrescriptionParam(createRequest: CreateRequest, options?: any): AxiosPromise<PrescriptionDefaultParam> {
            return localVarFp.createDefaultPrescriptionParam(createRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 처방 생성
         * @param {CreatePrescriptionRequest} createPrescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrescription(createPrescriptionRequest: CreatePrescriptionRequest, options?: any): AxiosPromise<Prescription> {
            return localVarFp.createPrescription(createPrescriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 자극 기본값 삭제
         * @param {string} prescriptionDefaultParamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDefaultPrescriptionParam(prescriptionDefaultParamId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDefaultPrescriptionParam(prescriptionDefaultParamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 처방 id 에 해당하는 처방 삭제
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrescriptionById(prescriptionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePrescriptionById(prescriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 토큰의 병원에 속한 미종결(대기·진행중) 처방을 최신 처방순으로 반환한다. includeClosedWithinDays 를 주면 오늘 포함 그 일수 안에 종결(완료·취소)된 처방도 함께 담는다(1~90, 벗어나면 400). 상태는 Prescription.Status 값만 담으며, 미동의·배송지 미입력·배송중 같은 배송 세부 상태는 이 응답에 없다 — 클라이언트가 배송 서버 정보와 결합해 구분해야 한다.
         * @summary 기관 미종결 처방 목록 조회 (이용 현황 화면)
         * @param {number} [includeClosedWithinDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActivePrescriptions(includeClosedWithinDays?: number, options?: any): AxiosPromise<Array<Prescription>> {
            return localVarFp.findActivePrescriptions(includeClosedWithinDays, options).then((request) => request(axios, basePath));
        },
        /**
         * 배송 서버가 발행한 옛 토큰(QX_DEVICE_USER)의 patientId/orgId 에 해당하는 처방 리스트를 반환합니다. 새 환자 서버 토큰은 GET /api/v1/me/prescriptions 를 사용하세요.
         * @summary 모바일 사용자 본인의 처방 목록 조회 (옛 배송 토큰 전용, deprecated)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findAllMyPrescriptions(options?: any): AxiosPromise<Array<Prescription>> {
            return localVarFp.findAllMyPrescriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 환자 id 에 해당하는 처방 조회
         * @param {string} patientId 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllPrescriptionsByPatientId(patientId: string, includeDeleted?: boolean, options?: any): AxiosPromise<Array<Prescription>> {
            return localVarFp.findAllPrescriptionsByPatientId(patientId, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 자극 기본값 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDefaultParam(options?: any): AxiosPromise<PrescriptionDefaultParam> {
            return localVarFp.findDefaultParam(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 처방 id 에 해당하는 처방 조회
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPrescriptionById(prescriptionId: string, options?: any): AxiosPromise<Prescription> {
            return localVarFp.findPrescriptionById(prescriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 배송완료 후 직원이 기기를 직접 교환합니다. 헌 기기는 회수 대기(RELEASING) 상태로 두고 새 기기를 활성화하며, 배송 deviceId 도 교체합니다. 헌 기기의 최종 상태는 회수·점검 단계에서 정합니다. YBRAIN 권한 소유자만 호출 가능합니다.
         * @summary 기기 직접 교환 (YBRAIN 전용)
         * @param {string} prescriptionId 
         * @param {ReplaceRequest} replaceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceDevice(prescriptionId: string, replaceRequest: ReplaceRequest, options?: any): AxiosPromise<Device> {
            return localVarFp.replaceDevice(prescriptionId, replaceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * prescription id 목록을 받아 해당 처방들을 한 번에 조회한다. 존재하지 않는 id 는 스킵(부분 성공)하고 삭제된 처방은 제외한다. YBRAIN 권한 소유자만 호출 가능하며 org 제약 없이 전체 처방을 대상으로 한다.
         * @summary 처방 id 목록 벌크 조회 (YBRAIN 전용)
         * @param {SearchPrescriptionRequest} searchPrescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPrescriptionsByIds(searchPrescriptionRequest: SearchPrescriptionRequest, options?: any): AxiosPromise<Array<Prescription>> {
            return localVarFp.searchPrescriptionsByIds(searchPrescriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 자극 기본값 업데이트
         * @param {string} prescriptionDefaultParamId 
         * @param {UpdateRequest} updateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultPrescriptionParam(prescriptionDefaultParamId: string, updateRequest: UpdateRequest, options?: any): AxiosPromise<PrescriptionDefaultParam> {
            return localVarFp.updateDefaultPrescriptionParam(prescriptionDefaultParamId, updateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrescriptionControllerApi - object-oriented interface
 * @export
 * @class PrescriptionControllerApi
 * @extends {BaseAPI}
 */
export class PrescriptionControllerApi extends BaseAPI {
    /**
     * 처방을 취소합니다. 병원 계정은 배송 요청 전까지만, YBRAIN 계정은 제약 없이 취소할 수 있습니다.
     * @summary 처방 취소
     * @param {string} prescriptionId 
     * @param {CancelPrescriptionRequest} cancelPrescriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public cancel(prescriptionId: string, cancelPrescriptionRequest: CancelPrescriptionRequest, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).cancel(prescriptionId, cancelPrescriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 자극 기본값 추가
     * @param {CreateRequest} createRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public createDefaultPrescriptionParam(createRequest: CreateRequest, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).createDefaultPrescriptionParam(createRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 처방 생성
     * @param {CreatePrescriptionRequest} createPrescriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public createPrescription(createPrescriptionRequest: CreatePrescriptionRequest, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).createPrescription(createPrescriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 자극 기본값 삭제
     * @param {string} prescriptionDefaultParamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public deleteDefaultPrescriptionParam(prescriptionDefaultParamId: string, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).deleteDefaultPrescriptionParam(prescriptionDefaultParamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 처방 id 에 해당하는 처방 삭제
     * @param {string} prescriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public deletePrescriptionById(prescriptionId: string, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).deletePrescriptionById(prescriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 토큰의 병원에 속한 미종결(대기·진행중) 처방을 최신 처방순으로 반환한다. includeClosedWithinDays 를 주면 오늘 포함 그 일수 안에 종결(완료·취소)된 처방도 함께 담는다(1~90, 벗어나면 400). 상태는 Prescription.Status 값만 담으며, 미동의·배송지 미입력·배송중 같은 배송 세부 상태는 이 응답에 없다 — 클라이언트가 배송 서버 정보와 결합해 구분해야 한다.
     * @summary 기관 미종결 처방 목록 조회 (이용 현황 화면)
     * @param {number} [includeClosedWithinDays] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public findActivePrescriptions(includeClosedWithinDays?: number, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).findActivePrescriptions(includeClosedWithinDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 배송 서버가 발행한 옛 토큰(QX_DEVICE_USER)의 patientId/orgId 에 해당하는 처방 리스트를 반환합니다. 새 환자 서버 토큰은 GET /api/v1/me/prescriptions 를 사용하세요.
     * @summary 모바일 사용자 본인의 처방 목록 조회 (옛 배송 토큰 전용, deprecated)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public findAllMyPrescriptions(options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).findAllMyPrescriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 환자 id 에 해당하는 처방 조회
     * @param {string} patientId 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public findAllPrescriptionsByPatientId(patientId: string, includeDeleted?: boolean, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).findAllPrescriptionsByPatientId(patientId, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 자극 기본값 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public findDefaultParam(options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).findDefaultParam(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 처방 id 에 해당하는 처방 조회
     * @param {string} prescriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public findPrescriptionById(prescriptionId: string, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).findPrescriptionById(prescriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 배송완료 후 직원이 기기를 직접 교환합니다. 헌 기기는 회수 대기(RELEASING) 상태로 두고 새 기기를 활성화하며, 배송 deviceId 도 교체합니다. 헌 기기의 최종 상태는 회수·점검 단계에서 정합니다. YBRAIN 권한 소유자만 호출 가능합니다.
     * @summary 기기 직접 교환 (YBRAIN 전용)
     * @param {string} prescriptionId 
     * @param {ReplaceRequest} replaceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public replaceDevice(prescriptionId: string, replaceRequest: ReplaceRequest, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).replaceDevice(prescriptionId, replaceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * prescription id 목록을 받아 해당 처방들을 한 번에 조회한다. 존재하지 않는 id 는 스킵(부분 성공)하고 삭제된 처방은 제외한다. YBRAIN 권한 소유자만 호출 가능하며 org 제약 없이 전체 처방을 대상으로 한다.
     * @summary 처방 id 목록 벌크 조회 (YBRAIN 전용)
     * @param {SearchPrescriptionRequest} searchPrescriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public searchPrescriptionsByIds(searchPrescriptionRequest: SearchPrescriptionRequest, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).searchPrescriptionsByIds(searchPrescriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 자극 기본값 업데이트
     * @param {string} prescriptionDefaultParamId 
     * @param {UpdateRequest} updateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    public updateDefaultPrescriptionParam(prescriptionDefaultParamId: string, updateRequest: UpdateRequest, options?: RawAxiosRequestConfig) {
        return PrescriptionControllerApiFp(this.configuration).updateDefaultPrescriptionParam(prescriptionDefaultParamId, updateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

